import { render, staticRenderFns } from "./SidebarBets.vue?vue&type=template&id=ca7a5dc6&scoped=true&"
import script from "./SidebarBets.vue?vue&type=script&lang=js&"
export * from "./SidebarBets.vue?vue&type=script&lang=js&"
import style0 from "./SidebarBets.vue?vue&type=style&index=0&id=ca7a5dc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7a5dc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca7a5dc6')) {
      api.createRecord('ca7a5dc6', component.options)
    } else {
      api.reload('ca7a5dc6', component.options)
    }
    module.hot.accept("./SidebarBets.vue?vue&type=template&id=ca7a5dc6&scoped=true&", function () {
      api.rerender('ca7a5dc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wheel/components/SidebarBets.vue"
export default component.exports